const PageSectionTitle = ({ children }) => {
    return (
        <div className="page-section-title">
           {children}
        </div>
    );
};

export default PageSectionTitle;
